module.exports = __webpack_public_path__ + "img/project3.8becadd8.png";